angular.module 'zc.projects'

.factory 'BaseCampaignInterestWidgetGraph', (CampaignStats, CampaignEventStats, AccessStats, Chart) ->
  class BaseCampaignInterestWidgetGraph
    start_event_name: 'iw_started'
    constructor: (@dimension) ->
    baseLink: (scope, elem, attrs) ->
      scope.path = =>
        apikey: scope.campaign.apikey
        dimension: @dimension

      scope.range = ->
        $gte: _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()])
        $lt: _.min([scope.campaign.end_at, moment(scope.filters.end_at).add(1, 'days').startOf('day').toDate()])

      scope.getCampaignEventStats = (name) ->
        CampaignEventStats.find scope.path(),
          match:
            name: name
            element_id: scope.campaign.element.id
            start_at: scope.range()

      scope.getAccessStats = ->
        AccessStats.findDefault scope.path(),
          device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device)
          campaign_segment_id: (scope.campaign.segment?.id or null)
          is_control: null
          start_at:
            $gte: _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()])
            $lt: _.min([scope.campaign.end_at, moment(scope.filters.end_at).add(1, 'days').startOf('day').toDate()])

      scope.getInterestWidgetItemDistribution = (is_cart_button_click) ->
        CampaignStats.getInterestWidgetItemDistribution scope.path(),
          match:
            is_cart_button_click: is_cart_button_click
            element_id: scope.campaign.element.id
            start_at: scope.range()
          pipeline: [
            $group:
              _id:
                from: "$from"
                to: "$to"
              count:
                $sum: "$count"
          ,
            $project:
              from: "$_id.from"
              to: "$_id.to"
              count: "$count"
          ,
            $sort:
              from: 1
          ]

      scope.updateData = ->
        scope.getChartConfig()
        scope.getStats()
        .then (stats) ->
          scope.addChartConfig stats

    watchFilters: (scope, elem, attrs) ->
      scope.$watch('filters', scope.updateData, true)

    createDirective: ->
      restrict: 'E'
      require: '?filters'
      scope:
        project : '='
        campaign: '='
        filters : '='
      template: '<highchart config="chartConfig"></highchart>'
      link: (scope, elem, attrs) =>
        @baseLink(scope, elem, attrs)
        @link(scope, elem, attrs) if @link
        @watchFilters(scope, elem, attrs)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/base_campaign_interest_widget_graph.coffee